// solves a problem where the PLP page scrolls to the top when clicking in the add to bag button
// please see https://nestle.atlassian.net/browse/ITNP-155604
export default function preventPlpScrolling() {
  if (typeof window !== 'undefined') window.preventPlpScrolling = true;
}
